// extracted by mini-css-extract-plugin
export var md = "768px";
export var navigationFooterContainer = "NavigationFooter_navigationFooterContainer__4I0Nj";
export var nextButton = "NavigationFooter_nextButton__wNrKB";
export var questionMargins = "NavigationFooter_questionMargins__k2nNo";
export var shared = "'../../shared.module.css'";